import { HTMLAttributes, ReactElement } from 'react';
import { Trans } from 'react-i18next';

interface Props extends HTMLAttributes<HTMLSpanElement> {
  tos: string;
  pp: string;
  linkClassName?: string;
}

export default function TosAndPpLinks({
  className = '',
  tos = '',
  pp = '',
  linkClassName
}: Props): ReactElement {
  return (
    <span className={`tos-and-pp-links ${className}`}>
      {tos && pp && (
        <Trans i18nKey="TosAndPpLinks.tosAndPp">
          <a href={tos} target="_blank" className={linkClassName} />
          <a href={pp} target="_blank" className={linkClassName} />
        </Trans>
      )}
      {!(tos && pp) && (
        <Trans i18nKey="TosAndPpLinks.tosOrPp">
          <a href={tos || pp} target="_blank" className={linkClassName} />
        </Trans>
      )}
    </span>
  );
}
